import GenericPossessionInfo from './GenericPossessionInfo';

const AnimalInfo = ({ customerRecords }) => (
  <GenericPossessionInfo
    customerRecords={customerRecords}
    possessionsKey="animals"
    optionLabel={(a) => [a.name, a.species].filter(Boolean).join(' - ') || 'Animal'}
  />
);

export default AnimalInfo;
